module.exports = __webpack_public_path__ + "img/10.1dd4d313.webp";